module.exports = __webpack_public_path__ + "img/hero.d78f9da0.jpg";